"use client";

import { Button, Stack, Typography } from "components";
import { withContent } from "contexts/content";

function PartnerWelcome({ redirect }) {
  return (
    <Stack component="section" alignItems="center" spacing={5} useFlexGap>
      <Typography variant="h2">
        ¡Bienvenido a BondUP, la primera red social de entretenimiento, salud y
        bienestar para personas +60!
      </Typography>
      <Button
        id="BB-register-1"
        className="BupButton-wide"
        color="inherit"
        onClick={() => redirect.register({ params: { signUpCode: "BCH" } })}
        size="large"
        variant="text"
      >
        Acceder al beneficio
      </Button>
    </Stack>
  );
}

export default withContent(PartnerWelcome);
